<template>
    <div>

        <kgr-loading v-if="isLoading" />
        <div v-else>
            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text">
                {{ $t('Offene Urlaubsanträge') }}
            </h3>
            <kgr-table class="kgr-table--block">
                <thead>
                    <tr class="kgr-table__row">
                        <kgr-th sortable>
                            {{ $t('federation.vacationRequests.kindergartenName') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Mitarbeiter') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Urlaub / Sonderurlaub') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Beginn') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Ende') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Urlaubstage') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Beantragt') }}
                        </kgr-th>
                        <kgr-th>&nbsp;</kgr-th>
                    </tr>
                </thead>
                <tbody v-if="vacationRequests.length > 0">
                    <tr
                        v-for="(vacationRequest, index) in vacationRequests"
                        :key="index"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            {{ vacationRequest.kindergarten.name }}
                        </td>
                        <td class="kgr-table__cell">
                            <a
                                class="kgr-link"
                                :href="getEmployeeVacationRequestUrl(vacationRequest.employee.id, vacationRequest.id)"
                                target="_blank"
                            >
                                {{ vacationRequest.employee.fullName }}
                            </a>
                        </td>
                        <td class="kgr-table__cell">
                            {{ vacationRequest.labelling }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ formatDate(vacationRequest.start) }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ formatDate(vacationRequest.end) }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ vacationRequest.days }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ formatDate(vacationRequest.createdAt) }}
                        </td>
                        <td class="kgr-table__cell">
                            <a
                                class="kgr-link"
                                :title="$t('Urlaubsantrag genehmigen')"
                                @click="accept(vacationRequest)"
                            >
                                <kgr-icon icon-class="check" />
                            </a>
                            <a
                                class="kgr-link"
                                :title="$t('Urlaubsantrag ablehnen')"
                                @click="reject(vacationRequest)"
                            >
                                <kgr-icon icon-class="block" />
                            </a>
                        </td>
                    </tr>
                </tbody>
            </kgr-table>
            <br />
            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text">
                {{ $t('Zuletzt bearbeitete Urlaubsanträge') }}
            </h3>
            <kgr-table class="kgr-table--block">
                <thead>
                    <tr class="kgr-table__row">
                        <kgr-th sortable>
                            {{ $t('federation.vacationRequests.kindergartenName') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Mitarbeiter') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Urlaub / Sonderurlaub') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Beginn') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Ende') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Urlaubstage') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Beantragt') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Genehmigt') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Bearbeitet') }}
                        </kgr-th>
                    </tr>
                </thead>
                <tbody v-if="vacationRequestsLastEdited.length > 0">
                    <tr
                        v-for="(vacationRequest, index) in vacationRequestsLastEdited"
                        :key="index"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            {{ vacationRequest.kindergarten.name }}
                        </td>
                        <td class="kgr-table__cell">
                            <a
                                class="kgr-link"
                                :href="getEmployeeVacationRequestUrl(vacationRequest.employee.id, vacationRequest.id)"
                                target="_blank"
                            >
                                {{ vacationRequest.employee.fullName }}
                            </a>
                        </td>
                        <td class="kgr-table__cell">
                            {{ vacationRequest.labelling }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ formatDate(vacationRequest.start) }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ formatDate(vacationRequest.end) }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ vacationRequest.days }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ formatDate(vacationRequest.createdAt) }}
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-icon
                                :icon-class="vacationRequest.approved ? 'check' : 'block'"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            {{ formatDateTime(vacationRequest.updatedByAdmin) }}
                        </td>
                    </tr>
                </tbody>
            </kgr-table>
        </div>
    </div>
</template>

<script>
import EventBus from '../../../js/service/EventBus.js';
import Icon from '../../../components/common/icon/Icon.vue';
import Loading from '../../../components/common/Loading.vue';
import VacationRequestRepository from '../../../js/repository/federation/VacationRequestRepository';
import {de} from 'date-fns/locale'
import {format} from '@legacy/js/date/date-fns.js'

export default {
    components: {
        'kgr-loading': Loading,
        'kgr-icon': Icon,
    },
    props: {
        federationId: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            loadingA: false,
            loadingB: false,
            vacationRequests: [],
            vacationRequestsLastEdited: [],
        }
    },
    computed: {
        isLoading() {
            return this.loadingA || this.loadingB;
        },
    },
    created() {
        this.loadVacationRequests(true);
        this.loadVacationRequestsLastEdited(true);
    },
    methods: {
        loadVacationRequests(loading) {
            this.loadingA = loading;
            VacationRequestRepository.findByFederationId(this.federationId, false)
                .then(response => this.vacationRequests = response)
                .catch(() => this.$notify.error('Daten konnten nicht geladen werden'))
                .finally(() => this.loadingA = false);
        },
        loadVacationRequestsLastEdited(loading) {
            this.loadingB = loading;
            VacationRequestRepository.findByFederationId(this.federationId, true)
                .then(response => this.vacationRequestsLastEdited = response)
                .catch(() => this.$notify.error('Daten konnten nicht geladen werden'))
                .finally(() => this.loadingB = false);
        },
        accept(vacationRequest) {
            VacationRequestRepository.update(this.federationId, vacationRequest.id, true)
                .then(() => {
                    this.removeAndReload(vacationRequest);
                    this.$notify.success('Der Urlaubsantrag wurde genehmigt');
                })
                .catch(() => this.$notify.error('saveChanges.error'));
        },
        reject(vacationRequest) {
            VacationRequestRepository.update(this.federationId, vacationRequest.id, false)
                .then(() => {
                    this.removeAndReload(vacationRequest);
                    this.$notify.success('Der Urlaubsantrag wurde abgelehnt');
                })
                .catch(() => this.$notify.error('saveChanges.error'));
        },
        removeAndReload(vacationRequest) {
            this.vacationRequests = this.vacationRequests.filter(request => vacationRequest.id !== request.id);
            this.loadVacationRequests(false);
            this.loadVacationRequestsLastEdited(false);
            EventBus.$emit('updatedCounterBadge', {name: 'vacationRequestBadge', value: this.vacationRequests.length})
        },
        formatDate(date) {
            return format(new Date(date), 'dd.MM.yyyy', {locale: de})
        },
        formatDateTime(dateTime) {
            return format(new Date(dateTime), 'dd.MM.yyyy HH:mm:ss', {locale: de})
        },
        getEmployeeVacationRequestUrl(employeeId, vacationRequestId) {
            return `/federation/login/employee/${employeeId}/vacation-request/${vacationRequestId}`;
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
